"use client";

import { AutoLogoffBanner } from "./AutoLogoffBanner";
import { useInactivityTimer } from "./InactivityTimer";

export function AutoLogoff() {
  const { status } = useInactivityTimer();
  return !status ? <AutoLogoffBanner status={status} /> : null;
}
